import React from 'react';

export interface Column<T> { key: string; header: string; render?: (row: T) => React.ReactNode; }

function DataTable<T extends Record<string, any>>({ columns, rows }: { columns: Column<T>[]; rows: T[] }) {
  return (
    <div className="overflow-x-auto bg-white rounded-lg border">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-left text-gray-500">
          <tr>{columns.map((c) => <th key={c.key} className="px-4 py-2 font-medium">{c.header}</th>)}</tr>
        </thead>
        <tbody className="divide-y">
          {rows.map((row, i) => (
            <tr key={row.id ?? i} className="hover:bg-gray-50">
              {columns.map((c) => <td key={c.key} className="px-4 py-2">{c.render ? c.render(row) : String(row[c.key] ?? '')}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
export default DataTable;
